module.exports = "pegasus_template/assets/email1-header-1.png";